import React, { useContext } from "react";
import PropTypes from "prop-types";
import { CSSTransition } from "react-transition-group";
import fadeTransitions from "../FilterOptions/fadeTransitions.module.scss";
import classes from "../filterBar.module.scss";
import { FilterContext } from "../context";

const Footer = ({ reset, close, apply, hideClearFiltersCta }) => {
  const { errors } = useContext(FilterContext);
  const canApply =
    typeof apply === "function" &&
    Object.values(errors).filter(Boolean).length === 0;

  return (
    <footer>
      {!hideClearFiltersCta && (
        <CSSTransition
          in={typeof reset === "function"}
          timeout={300}
          key="clear"
          classNames={fadeTransitions}
          unmountOnExit
        >
          <button type="button" className={classes.clearButton} onClick={reset}>
            Clear filters
          </button>
        </CSSTransition>
      )}
      <button
        type="button"
        className={classes.applyButton}
        onClick={() => {
          apply();
          close();
        }}
        disabled={!canApply}
      >
        Apply
      </button>
    </footer>
  );
};

Footer.propTypes = {
  reset: PropTypes.func,
  close: PropTypes.func.isRequired,
  apply: PropTypes.func,
};

export default Footer;
